import { Component, Input, OnInit } from '@angular/core';
import { User } from '@classes/user/user';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  @Input() user: User;

  constructor(
    private authSrv: AuthService
  ) { }

  ngOnInit() {
  }

  onLogout(): void {
    this.authSrv.logout();
  }

}
